
import { Box, Container } from '@mui/material';
import FreeChapterSection from '../components/FreeChapterSection';
import ThroughThisChapter from '../components/ThroughThisChapter';
import OnlyToolYouNeed from '../components/OnlyToolYouNeed';
import BookChapterMyFamily from '../components/BookChapterMyFamily';
import MeetSara from '../components/MeetSara';
import Footer from '../components/Footer';
import SignUpforFreeChapter from '../components/SignUpforFreeChapter';
const FreeChapter = () => {
    return (
        <Box sx={{ bgcolor: 'background.default', color: 'text.primary' }}>
            <Container maxWidth="lg">
                <FreeChapterSection />
                <ThroughThisChapter />
                <OnlyToolYouNeed />
                <BookChapterMyFamily />
                <MeetSara />
                <SignUpforFreeChapter />
            </Container>
        </Box>
    );
};

export default FreeChapter;